$(document).ready(function() {
  $('.open-menu').on('click', function(e) {
    e.preventDefault();

    $('#site-header').addClass('open');
  });

  $('.close-menu .link-menu').on('click', function(e) {
    e.preventDefault();

    $('#site-header').removeClass('open');
  });

  if ($(window).width() < 1200) {
    $('#site-header .dropdown').click(function(e) {
      e.preventDefault();

      if ($(this).hasClass('open')) {
        $(this).removeClass('open');
        $('#site-header .dropdown ul').stop().slideUp(350);
        return false;
      }

      $('#site-header .dropdown').removeClass('open');
      $(this).addClass('open');

      $('#site-header .dropdown ul').stop().slideUp(350);

      $('#site-header .dropdown.open ul').slideToggle(300);
    });
  }

  $('#site-header .close-menu').click(function(e){
    e.preventDefault();

    $('#site-header .main-menu').fadeOut(250);
    $('#site-header .menu-user').fadeOut(250);
    $('#site-header .menu-login').fadeOut(250);
  });

  $('#site-header .open-menu-main').click(function(e) {
    e.preventDefault();
    $('#site-header #site-nav .main-menu').fadeIn(250);
  });

  $('#site-header .open-menu-user').click(function(e) {
    e.preventDefault();
    $('#site-header .menu-user').fadeIn(250);
  });

  $('#site-header .back-menu-user').click(function(e) {
    e.preventDefault();
    $('#site-header .menu-user').fadeIn(250);
    $('#site-header .menu-login').stop().fadeOut(250);
  });

  $('#site-header .open-menu-login').click(function(e) {
    e.preventDefault();
    $('#site-header .menu-login').fadeIn(250);
  });
});

$(window).on('resize load', function() {
  if ($(window).width() < 1200) {
    $('#site-header *').attr('style', '');
  }
});
